import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function DatabaseLock({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M4 14.11C4 15.57 7.37 16.75 11.53 16.75M19 5.63999C19 7.09999 15.64 8.27999 11.5 8.27999C7.35 8.27999 4 7.08999 4 5.62999M19 9.87999C19 11.34 15.64 12.52 11.5 12.52C7.35 12.52 4 11.33 4 9.86999M19.723 18V16.72C19.723 15.81 18.943 14.99 17.993 14.99C17.033 14.99 16.263 15.76 16.263 16.71V17.98M11.536 21C7.374 21 4 19.81 4 18.35V5.63999C4 4.16999 7.35 2.98999 11.5 2.98999C15.64 2.98999 19 4.16999 19 5.62999V11.98M20.026 22H15.974C15.434 22 14.994 21.56 14.994 21.02V18.96C14.994 18.42 15.424 17.98 15.964 17.98H20.016C20.546 17.98 20.986 18.41 20.986 18.95V21C20.986 21.53 20.546 21.97 20.006 21.97L20.026 22Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default DatabaseLock;